import React from 'react';

import MoneyCore from 'coreComponents/Money';
import {IMoneyProps} from 'coreComponents/Money/IMoney';
import {getConfig} from 'coreUtils/utils';

const Money = ({value, currency, classNames = '', spaceBetweenCurrencyAndPrice = true}: IMoneyProps) => {
	return (
		<MoneyCore
			value={value}
			currency={currency}
			classNames={classNames}
			showLocalizedPrices={getConfig().app.showLocalizedPrices}
			spaceBetweenCurrencyAndPrice={spaceBetweenCurrencyAndPrice}
		/>
	);
};

export default Money;
